import { Form, Formik, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class SsoForm extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        key: '<tenant UUID leave blank for sandbox>'
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            required={true}
            label="Key"
            type="text"
            name="key"
            InputLabelProps={{
                shrink: true,
            }}
            margin="normal"
            variant="outlined"
            placeholder="Key"
            fullWidth={true}
            value={p.values.key || ''}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <Button style={{width: '100%'}} type="submit" color="primary">Integrate</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(SsoForm));



// WEBPACK FOOTER //
// ./src/sub-projects/fusionfabric/components/sso-form.tsx